import { BasePanel } from "./BasePanel";

export class ProgressBarPanel extends BasePanel {
  constructor(manager) {
    super(manager);
  }

  async init() {
    this.bar = this.uilib.createProgressBar({
      width: 1.8,
      height: 0.04,
      radius: 0.02,
      renderOrder: 222222,
    });
    this.uilib.addUIToScene(this.bar);
    this.bar.position.y = 0.2;

    this.bar.hide();
  }

  /**
   * 设置进度条的值
   * @param {*} value 0-100
   */
  setValue(value) {
    if (this.timeEvent) {
      clearTimeout(this.timeEvent);
      this.timeEvent = null;
    }

    // 将值转换为0-1并保留一位小数
    value = Math.min(Math.max(value, 0), 100);
    value /= 100;
    value = Math.round(value * 10) / 10;

    if (this.bar.visible === false) {
      this.bar.show();
    }

    this.bar.setValue(value);

    // 进度值到达1时，自动隐藏
    if (value >= 1) {
      this.timeEvent = setTimeout(() => {
        this.bar.hide();
      }, 500);
    }
  }
}
